import { ref } from 'vue';
import { auth } from '@/firebase';
import { getLogBuffer } from './useLogBuffer';

const CLOUD_FUNCTION_URL = 'https://us-central1-mesh-db-stg.cloudfunctions.net/bugReport';

const isOpen   = ref(false);
const snapshot = ref(null);

export function useBugReport() {
  function open(route, storeState) {
    snapshot.value = {
      route: {
        path:   route.path,
        name:   route.name,
        params: { ...route.params },
        query:  { ...route.query },
      },
      user: storeState.user
        ? { name: storeState.user.name, email: storeState.user.email, role: storeState.user.role }
        : null,
      device: storeState.device
        ? { id: storeState.device.id, name: storeState.device.name }
        : null,
      template: storeState.template
        ? { id: storeState.template.id, name: storeState.template.name }
        : null,
      logs:    getLogBuffer(),
      browser: {
        userAgent:    navigator.userAgent,
        screenWidth:  screen.width,
        screenHeight: screen.height,
        url:          window.location.href,
      },
      timestamp: new Date().toISOString(),
    };
    isOpen.value = true;
  }

  function close() {
    isOpen.value  = false;
    snapshot.value = null;
  }

  async function submit(form, screenshotDataUrl) {
    if (!auth.currentUser) throw new Error('Not authenticated');
    const token = await auth.currentUser.getIdToken();
    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type':  'application/json',
      },
      body: JSON.stringify({
        form,
        snapshot:   snapshot.value,
        screenshot: screenshotDataUrl ?? null,
      }),
    });
    if (!response.ok) throw new Error(`Submit failed: ${response.status}`);
    return response.json();
  }

  return { isOpen, snapshot, open, close, submit };
}
